import { create } from 'zustand';

export const useChatStore = create((set) => ({
  activeParcelId: null,
  sessions: {},
  messages: {},

  setActiveParcel: (parcelId) => set({ activeParcelId: parcelId }),

  setSession: (parcelId, session) =>
    set((s) => ({ sessions: { ...s.sessions, [parcelId]: session } })),

  setMessages: (parcelId, msgs) =>
    set((s) => ({ messages: { ...s.messages, [parcelId]: msgs } })),

  addMessages: (parcelId, newMsgs) =>
    set((s) => ({
      messages: {
        ...s.messages,
        [parcelId]: [...(s.messages[parcelId] || []), ...newMsgs],
      },
    })),
}));
